import  queryString  from "query-string";

export const getUrlKeys = search => queryString.parse(search);